export const emptyTableIndicatorText = {
  display: "flex",
  justifyContent: "center",
  height: "5vh",
  alignItems: "center",
};
